import { ACTIONS, EVENTS } from 'react-joyride';
import { CustomStep } from './Tutorial';

export const projectDetailsSteps = (): CustomStep[] => {
  const steps: CustomStep[] = [
    // {
    //   content: "Click here to archive a project that is no longer active.",
    //   target: '#tab-drawer-icon-0',
    //   disableBeacon: true,
    //   placement: 'auto',
    //   [ACTIONS.NEXT]: {
    //     [EVENTS.TARGET_NOT_FOUND]: "openProjectDetailsDrawer"
    //   },
    //   [ACTIONS.PREV]: {
    //     [EVENTS.STEP_AFTER]: [["toggleCalendar", "closeProjectDetailsDrawer"], 500],
    //   }
    // },
    // {
    //   content: "Click here to change and save the name of your project.",
    //   target: '#tab-drawer-title-box',
    //   disableBeacon: true,
    //   placement: 'auto',
    // },
    {
      content: 'Update project information here.',
      target: '#project-info',
      disableBeacon: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.TARGET_NOT_FOUND]: 'openProjectDetailsDrawer',
      },
      [ACTIONS.PREV]: {
        [EVENTS.STEP_AFTER]: [
          ['toggleCalendar', 'closeProjectDetailsDrawer'],
          500,
        ],
      },
    },
    {
      content: 'Add new project teammates here.',
      target: '#table-array-add-project-contact',
      disableBeacon: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.STEP_AFTER]: 'closeProjectDetailsDrawer',
      },
      [ACTIONS.PREV]: {
        [EVENTS.TARGET_NOT_FOUND]: 'openProjectDetailsDrawer',
      },
    },
  ];
  return steps;
};
